import React from "react"

type PayflexStepProps = {
  stepCount: number
  label: string
  title: string
  altTitle?: string
  altLabel?: string
}

const PayflexStep = ({
  stepCount,
  label,
  title,
  altTitle,
  altLabel,
}: PayflexStepProps) => {
  return (
    <div className="flex flex-row gap-[38px] font-open-sans">
      <div className="flex min-h-32 min-w-32 gap-16">
        <h3 className="text-h3 font-bold">{stepCount.toString()}</h3>
      </div>
      <div>
        <div className="flex flex-col gap-10 pt-2">
          <p className="text-body-lg font-bold uppercase text-payflex-purple">
            {title}
          </p>
          <p className="text-body-sm font-semibold uppercase text-payflex-navy">
            {label}
          </p>
        </div>
        {altTitle && altLabel && (
          <>
            <p className="mt-20 text-body-sm font-semibold uppercase text-payflex-navy">
              OR
            </p>
            <div className="flex flex-col gap-10 pt-2">
              <p className="text-body-lg font-bold uppercase text-payflex-purple">
                {altTitle}
              </p>
              <p className="text-body-sm font-semibold uppercase text-payflex-navy">
                {altLabel}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PayflexStep
